import React from 'react';
import { observer } from 'mobx-react';

import type { AccordionHeaderProps } from 'shared/Accordion/components/AccordionWrapper';
import AccordionFormHeader from '../AccordionFormHeader';

export interface ShipmentInstructionHeaderProps extends AccordionHeaderProps {
  completed: boolean;
}

const ShipmentInstructionsHeader = ({
  expanded,
  completed,
}: ShipmentInstructionHeaderProps) => (
  <AccordionFormHeader
    expanded={expanded}
    headline={I18n.translate('exports.form.shipment.header')}
    completed={completed}
  />
);

export default observer(ShipmentInstructionsHeader);
